import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../shared";
import { MsDashboardUpdateRequest } from "./shared/MsDashboardUpdateRequest";
@Injectable()
export class DashboardMultiStationService {
	constructor(private httpclientService: HttpclientService) {}

	FacilitySelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Dashboard/FacilitySelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	VisitorSnapshotStatsSelect(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorSnapshotStatsSelect?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BlockedListAttemptStatsSelect(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/BlockedListAttemptStatsSelect?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BlockedAttemptDetailsInfoSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/BlockedAttemptDetailsInfoSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetPhotoByVisitorPass(VisitorPassID) {
		var postResult$ = new Subject();
		var url = "MultiStation/GetPhotoByVisitorPass?VisitorPassID=" + VisitorPassID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorScanStationInfoSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorScanStationInfoSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	TodaysVisiteesSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/TodaysVisiteesSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	DashboardGraphOptionSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/DashboardGraphOptionSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	DashboardGraphDataSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/DashboardGraphDataSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DashboardPreferenceSelect() {
		var postResult$ = new Subject();
		var url = "MultiStation/DashboardPreferenceSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DashboardPreferenceUpdate(parms: MsDashboardUpdateRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/DashboardPreferenceUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	WaitingForVerificationInfoSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/WaitingForVerificationInfoSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	TodaysReasonsSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/TodaysReasonsSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
